import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import FormDetailPage from './FormDetail.page';

import {
  getForm,
  getBillerOfForm,
  deleteForm,
  updateForm,
  checkFormToDelete,
} from '../../redux/actions/forms';

const mapStateToProps = state => ({
  formDetail: state.allbiller.formDetail,
  billerOfForm: state.allbiller.billerOfForm,
  linked: state.allbiller.allowedToDelete,
  loading: state.allbiller.loading,
});

const mapDispatchToProps = {
  getForm,
  getBillerOfForm,
  deleteForm,
  updateForm,
  checkFormToDelete,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(FormDetailPage));
